import {Component, ElementRef, OnInit, ViewChild} from '@angular/core';
import {Product} from '../interface/product';
import {QuantityCalculationService} from '../service/quantity-calculation.service';
import {ProductDetailsTransmissionService} from 'src/app/raintree/transmission/product-details/product-details-transmission.service';
import {ProductInFinishProduct} from '../interface/product-in-finish-product';
import {RequestMapperService} from 'src/app/request-mapper.service';
import {ActivatedRoute, Router} from '@angular/router';
import {PriceCalculationService} from '../service/price-calculation.service';
import {GlobalService} from 'src/app/services/global.service';
import {CartCalculationService} from 'src/app/cart/service/cart-calculation.service';
import {FinishProfileItem} from '../interface/finish-profile-item-list';
import {GetAndSetCartDataInLocalstorageService} from 'src/app/cart/service/set-cart-data-in-localstorage.service';
import {PrepareInstockCalculationService} from '../service/prepare-instock-calculation.service';
import {VolumeDiscountProfile} from '../interface/volume-discount-profile';
import {SeoComponent} from "../../seo/interface/seo-component";
import {TwitterCardType} from "../../seo/model/twitter-card-type";
import {BrowserAPIService, SeoData, SeoService} from "@bloomscorp/ngbase";
import {BloomsightService} from "../../bloomsight.service";
import {isEmptyString} from "bmx-pastebox";
import {IReviewStats} from "../../review/interface/review-stats";
import {ReviewTransmissionService} from "../../raintree/transmission/review-transmission.service";
import {GtagAPIService} from "@bloomscorp/ngx-gtag";
import {AddStructuredDataService} from "../../add-structured-data.service";
import {MadeToOrderProfile} from "../interface/made-to-order-profile";
import {CurrencyResolverService} from "../../currency-resolver.service";

@Component({
	selector: 'fb-product-details',
	templateUrl: './product-details.component.html',
	styleUrls: ['./product-details.component.scss']
})
export class ProductDetailsComponent implements OnInit, SeoComponent {

	@ViewChild('reviewSection') reviewComponent: ElementRef | undefined;
	@ViewChild('estimated') cartButton: ElementRef | undefined;

	protected stars: boolean[] = Array(5).fill(0);
	protected reviewCount: number = 0;
	protected rating: number = 0;
	public isStoryListVisible: boolean = false;
	public isPreOrderPopOpen: boolean = false;
	public productData: Product = {} as Product;
	public isVolumeDiscountClose: boolean = false;
	public addOnImage: string = '';
	public reload: boolean = true;
	public MTOImage: string | undefined = '';
	public wholeResponse: ProductInFinishProduct = {} as ProductInFinishProduct;
	public copyQuantity: number = {} as number;
	public productDataShow: boolean = false;
	public isTheOrderInStock: boolean = true;
	public itemInStockForPass: number = 0;
	public isFinishShow: boolean = true;
	public triggerCartClose: boolean = true;
	public isCusomizationOpen: boolean = false;
	public isThisProductFabric: boolean = false;
	public isAnimationStopped: boolean = false;
	public isCartDisable: boolean = false;

	constructor(
		private _quantiCalculation: QuantityCalculationService, //TODO: later ref
		private _pdTransService: ProductDetailsTransmissionService,
		private _activatedRoute: ActivatedRoute,
		private _priceCalculation: PriceCalculationService,
		public _globalService: GlobalService,
		private _cartCalculation: CartCalculationService,
		private _getCartDataInLocal: GetAndSetCartDataInLocalstorageService,
		private _prepareItemInStockCalculation: PrepareInstockCalculationService,
		private _api: ReviewTransmissionService,
		private _router: Router,
		private _seo: SeoService,
		private _bloomsight: BloomsightService,
		private _gtag: GtagAPIService,
		private _browser: BrowserAPIService,
		private _structured: AddStructuredDataService,
		private _currencyResolver: CurrencyResolverService
	) {
	}

	private _prepareSlug(): void {

		const url: string = this._router.url;
		const urlParts: string[] = url.split('/');
		const category: string = urlParts[2];
		const slug: string = urlParts[3];

		this._cartCalculation.finishedProductId = 0
		this._cartCalculation.fabricProductId = 0;

		switch (category) {
			case 'fabric-product':
				this.getProductDetailsFabric(RequestMapperService.GET_PRODUCT_DETAILS_FABRIC + slug);
				this._cartCalculation.productGroup = 'fabric';
				this._priceCalculation.isThisProductFabric = true;
				this.isThisProductFabric = true;
				this.isCusomizationOpen = false;
				break;
			case 'finished-product':
				this.getProductDetailsFinish(RequestMapperService.GET_PRODUCT_DETAILS_FINISH + slug);
				this._cartCalculation.productGroup = 'finished';
				this._priceCalculation.isThisProductFabric = false;
				this.isThisProductFabric = false;
				this.isCusomizationOpen = true;
				break;
			default:
				break;
		}

		// TODO: what is this used for?
		if (this._browser.isBrowser())
			localStorage.removeItem('isPreOrderPopupOpen');
	}

	private _initProductGallerySEO(product: Product): void {

		if (isEmptyString(product.heroImageAlt))
			product.heroImageAlt = product.name;

		if (isEmptyString(product.hoverImageAlt))
			product.heroImageAlt = product.name;
	}

	public openVolumeDiscount(): void {
		this.isVolumeDiscountClose = true;
		this._globalService.popUpOpenClose(true);
	}

	public updateImageToDisplay(evt: string): void {
		this.addOnImage = evt;
		if (evt == '') {
			this.reload = false;
			setTimeout(() => this.reload = true, 0)
		}
	}

	public updateQuantity(evt: number): void {
		if (!evt) {
			this.productData.totalQuantity = this.copyQuantity;

			this.isFinishShow = false;
			setTimeout(() => this.isFinishShow = true, 0)
			return
		}

		this.productData.totalQuantity = evt;
	}

	public getProductDetailsFinish(url: string): void {
		this._pdTransService.getProductDetailsFinish(
			url,
			(): void => {
			},
			(response: ProductInFinishProduct): void => {
			},
			(response: ProductInFinishProduct): void => {
				this.setProductData(response);
				this._cartCalculation.finishedProductId = response.id;
				this.isStoryListVisible = true;

				this._bloomsight.trackDataEvent(
					'65b89f9fadae2d98edc82a62',
					{sku: response.product.sku},
					''
				);

			},
			(error: string): void => {
				if (this._browser.isBrowser()) {
					this._router.navigate(['/404']).then((): void => {
					});
				}
			},
			(): void => {
				// this.isLoading = false;
			},
		)
	}

	public getProductDetailsFabric(url: string): void {
		this._pdTransService.getProductDetailsFabric(
			url,
			(): void => {
			},
			(): void => {
			},
			(response: ProductInFinishProduct): void => {
				this.setProductData(response);
				this._cartCalculation.fabricProductId = response.id;
				this.isStoryListVisible = true;

				this._bloomsight.trackDataEvent(
					'65b89f9fadae2d98edc82a62',
					{sku: response.product.sku},
					''
				);

			},
			(error: string): void => {
				if (this._browser.isBrowser()) {
					this._router.navigate(['/404']).then((): void => {
					});
				}
			},
			(): void => {
			},
		)
	}

	public setProductData(data: ProductInFinishProduct): void {
		this.productData = data.product;
		this.wholeResponse = data;
		this.productDataShow = true;
		this.copyQuantity = this.productData.totalQuantity;
		this.calculationDefaultValue();
		this.calculationPrice(this.productData);
		this.calculateDefaultCartItem(this.productData);
		this.initSEO();
		this._fireGTag();
	}

	public calculationDefaultValue(): void {
		// for quantity calculation start
		this._quantiCalculation.availableSizeList = this.productData.productSizeProfileList!

		this._quantiCalculation.madeToOrderProfile = this.productData.madeToOrderProfileEnabled ? this.productData.madeToOrderProfile : undefined;
		this._quantiCalculation.madeToOrderProfileConsumedFabric = this.productData.madeToOrderProfileEnabled?  this.productData.madeToOrderProfile?.consumedFabric!: 0;


		this._quantiCalculation.productMadeFabric = this.productData.madeToOrderFabric!

		this._quantiCalculation.sizeList = this.productData.sizeProfileEnabled ? this.productData.sizeProfile?.sizeProfileOptionList! : [];

		this._quantiCalculation.selectedAvailableSizeQuantity = this.productData.madeToOrderProfileEnabled?  this.productData.madeToOrderProfile?.consumedFabric!: 0;

		this._quantiCalculation.selectedFabricQuantity = this.productData.madeToOrderFabric?.totalQuantity ? this.productData.madeToOrderFabric?.totalQuantity : 0;

		this._quantiCalculation.defaultProductQTY = this.productData.totalQuantity;

		this._quantiCalculation.madeToOrderConsumeFabric = this.productData.madeToOrderProfileEnabled ? this.productData.madeToOrderProfile?.consumedFabric! : 0;

		this.MTOImage = this.productData.madeToOrderFabric?.heroImage
		setTimeout((): void => {
			this._quantiCalculation.onLoadQuantityCalculation()
		}, 0);


		this._prepareItemInStockCalculation.prepareItemInstockCalculation(this.productData)

	}

	public calculationPrice(data: Product): void {


		this._priceCalculation.madeToOrderConsumedFabric = data.madeToOrderProfileEnabled ? data.madeToOrderProfile?.consumedFabric! : 0;

		this._priceCalculation.defaultProductPrice = data.price;
		let consumedFabric: number | undefined = data.sizeProfileEnabled ? data.sizeProfile?.sizeProfileOptionList[0].consumedFabric: 0;
		this._priceCalculation.selectedConsumedFabric = consumedFabric ? consumedFabric : 0;
		this._cartCalculation.selectedConsumedFabric = consumedFabric ? consumedFabric : 0;
		this._priceCalculation.productVolumeDiscountProfile = data.volumeDiscountProfileEnabled && data.volumeDiscountProfile ? data.volumeDiscountProfile : {} as VolumeDiscountProfile;

		setTimeout(() => this._priceCalculation.calculatePrice(false, true, 'product-details'), 0);
	}

	public calculateDefaultCartItem(data: Product): void {
		this._cartCalculation.wholeProductData = data;
		this._cartCalculation.defaultProductPrice = data.price;

		if (data.fabricProfileEnabled && data.fabricProfile) {
			this._cartCalculation.selectedFabricItem =
				(data.madeToOrderProfileEnabled && data.madeToOrderFabric) ? data.madeToOrderFabric :
					data.fabricProfile!.fabricProfileItemList[0].fabricPreview;
		}


		this._cartCalculation.selectedSize =
			data.sizeProfileEnabled && data.sizeProfile ? data.sizeProfile.sizeProfileOptionList[0] : undefined;


		if (data.finishProfileEnabled && data.finishProfile?.finishProfileItemList[0]) {
			let id: string = this.productData.finishProfileItemId ? this.productData.finishProfileItemId : '';
			let inStockIds: string[] = id.split(",");

			this.productData.finishProfile?.finishProfileItemList.forEach((elm: FinishProfileItem) => {

				inStockIds.forEach((id: string): void => {
					if (+id == elm.id) {
						this._cartCalculation.selectedFinishForCartCalc.push(
							elm
						)
					}
				});
			});
		}

		this._cartCalculation.orderType = "IN_STOCK";
		this._cartCalculation.unit = data.unit;

	}

	public ngOnInit(): void {
		this._prepareSlug();
		this.resolveReviewStats();
		this._getCartDataInLocal.openCartModal.subscribe((isCartClose: boolean): void => {
			if (!isCartClose) {

				this._cartCalculation.selectedFinishForCartCalc = [];
				this.isFinishShow = false;
				this.triggerCartClose = false;

				setTimeout((): void => {
					this.isFinishShow = true;
					this.triggerCartClose = true;
				}, 100)
			}
		});

		this._globalService.isTheOrderInstock.subscribe((isTheOrderInstock: boolean): void => {
			this.isTheOrderInStock = isTheOrderInstock;
		});

		this._globalService.disableAddToCart.subscribe((isCartDisable: boolean): void => {
			this.isCartDisable = isCartDisable;
		});
	}

	public preOrderOpen(): void {
		this.isPreOrderPopOpen = true;
		this._globalService.popUpOpenClosePreorder(true);
		this._cartCalculation.orderType = "PRE_ORDER"

	}

	public preOrderClose(isCloseButtonClicked?: boolean): void {

		this.isPreOrderPopOpen = false;

		// TODO: what is this used for?
		if (this._browser.isBrowser())
			localStorage.removeItem('isPreOrderPopupOpen');

		this._globalService.popUpOpenClosePreorder(false);

		if (isCloseButtonClicked) {
			this._cartCalculation.orderType = this._cartCalculation.previouslySelectedOrderType;
			this._getCartDataInLocal.openCartModal.next(false);
			this._cartCalculation.isPreorder = false;

			// this._priceCalculation.productQuantity = 1;
			// if(!this.productData.fabricProfile && !this.productData.madeToOrderFabric ){
			this.calculationPrice(this.productData);
			// }
		}

	}

	public passQtyToCartButton(maxQty: number): void {
		this.itemInStockForPass = maxQty;
	}

	public initSEO(): void {

		const productDescription: string = this.productData.metaDescription?  this.productData.metaDescription : this._structured.removeHtmlTags(this.productData.productOverview);
		const productName: string = this.productData.metaTitle? this.productData.metaTitle : this.productData.name;

		const seoData: SeoData = {
			title: productName,
			tags: {
				description: {
					charset: 'utf-8',
					name: 'description',
					content: productDescription
				}
			},
			facebook: {
				title: productName,
				type: 'website',
				description: productDescription,
				image: {
					url: this.productData.heroImage,
					type: 'image/jpeg',
					width: '600',
					height: '600',
					alt: productName
				},
				url: `https://anuprerna.com${this._router.url}`
			},
			twitter: {
				title: productName,
				description: productDescription,
				cardType: TwitterCardType.SUMMARY_LARGE,
				image: {
					url: this.productData.heroImage,
					alt: productName
				}
			}
		};

		this._seo.set(seoData);
		this._initProductGallerySEO(this.productData);
		this._structured.mapToProductStructure(this.productData);
		this._structured.mapToProductMerchantListingStructure(this.productData);
	}

	public triggerCustomizeOption(): void {
		this._bloomsight.trackDataEvent(
			'65b89cd5adae2d98edc829c4',
			{sku: this.productData.sku},
			''
		);
		this.isAnimationStopped = true;
		this.isCusomizationOpen = !this.isCusomizationOpen;
	}

	private resolveReviewStats(): void {
		this._api.getReviewStats(
			() => {
			},
			() => {
			},
			(response: IReviewStats) => {
				this.reviewCount = response.count;
				this.rating = response.rating;
			},
			(error: string) => {
			},
			() => {
			}
		);
	}

	private _fireGTag(): void {

		const price: number = (this._priceCalculation.storediscountedPrice > 0) ? this._priceCalculation.storediscountedPrice : this.productData.price;

		this._gtag.sendEventData({
			action: 'view_item',
			event: 'view_item',
			// send_to: 'GTM-PH84L4F',
			ecommerce: {
				currency: this._currencyResolver.getSelectedCurrency().toString(),
				value: price,
				items: [{
					item_name: this.productData.name,
					item_id: this.productData.sku,
					price: price,
					item_price: price,
					item_category: this.productData.category.name,
					item_currency: this._currencyResolver.getSelectedCurrency().toString()
					// quantity: 1
				}]
			}
		});
	}

	protected onOverallReviewClick() {
		this.reviewComponent?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center'});
	}

	protected onMadeToOrderClick() {
		console.log('click');
		this.cartButton?.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center'});
	}
}
